// extracted by mini-css-extract-plugin
module.exports = {"page":"CheckoutPage-page-1J5968"};